export default __webpack_public_path__ + "static/jetson_product_1-2d6018613fa830208353508c1e68da10.png";